import { gql } from '@apollo/client';

export default gql`
  mutation CreateCorporateDeviceMutation(
    $corporateDevice: CorporateDeviceInput!
  ) {
    createCorporateDevice(input: { corporateDevice: $corporateDevice }) {
      corporateDevice {
        id
      }
    }
  }
`;
